import { createCachedSelector } from 're-reselect';

import { at } from '@iconik-io/core/src/at';

import type { NormalizedEntitiesMap } from '../entities/types';
import type { BaseAppState } from '../types';
import type { IndexedEntity, IndexedEntityFields } from './indexes';

type IndexSelectorFunction<
  EntityKey extends IndexedEntity,
  AppState extends BaseAppState,
> = (
  state: AppState,
  indexValue: string | undefined,
) => NormalizedEntitiesMap[EntityKey][];

export const indexSelectorCacheKey = (
  _state: BaseAppState,
  indexValue: string | undefined,
) => indexValue ?? 'empty';

export const createEntitiesIndexSelector = <
  EntityKey extends IndexedEntity,
  AppState extends BaseAppState,
>(
  entityKey: EntityKey,
  indexKey: IndexedEntityFields[EntityKey],
): IndexSelectorFunction<EntityKey, AppState> =>
  createCachedSelector(
    (state: AppState) => state.entitiesIndex[entityKey][indexKey],
    (state: AppState) => state.entities[entityKey],
    (_state: AppState, indexValue: string | undefined) => indexValue,
    (index, entities, indexValue) =>
      indexValue && index?.[indexValue]
        ? at(entities, Object.keys(index[indexValue]))
        : [],
  )(indexSelectorCacheKey);
